import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutComponent } from './layout.component';
import { Route, RouterModule } from '@angular/router';
import { StandardOrderComponent } from '../modules/standard-order/standard-order.component';
import { BulkOrderComponent } from '../modules/bulk-order/bulk-order.component';
import { BulkOrderModule } from '../modules/bulk-order/bulk-order.module';
import { StandardOrderModule } from '../modules/standard-order/standard-order.module';
import { MatDialogModule } from '@angular/material/dialog';
import { HomeComponent } from '../modules/home/home.component';
import { HomeModule } from '../modules/home/home.module';
import { AuthGuardGuard } from '../core/auth/guards/auth-guard.guard';
import { AfterOrderScreenComponent } from '../modules/after-order-screen/after-order-screen.component';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatRippleModule } from '@angular/material/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CommonComponentsModule } from 'src/@order/components/common-components.module';
import { PendingChangesGuard } from '../core/auth/guards/pending-changes.guard';
import { CountryRoutingGuard } from '../core/auth/guards/country-routing.guard';
import { WalletLayoutComponent } from '../modules/phlenu-wallet/wallet-layout/wallet-layout.component';
import { PhlenuWalletModule } from '../modules/phlenu-wallet/phlenu-wallet.module';
import { WalletPaymentHandlingComponent } from '../modules/phlenu-wallet/wallet-payment-handling/wallet-payment-handling.component';
import { OrderSuccessComponent } from '../modules/order-success/order-success.component';
import { PendingFeedbackListingComponent } from '../modules/pending-feedback-listing/pending-feedback-listing.component';
import { PendingFeedbackListingModule } from '../modules/pending-feedback-listing/pending-feedback-listing.module';
import { InterRegionalComponent } from '../modules/inter-regional/inter-regional.component';
import { InterRegionalModule } from '../modules/inter-regional/inter-regional.module';
import { OrderInterRegionalDetailsComponent } from '../modules/order-details/order-inter-regional-details/order-inter-regional-details.component';
import { HeavyItemsComponent } from '../modules/heavy-items/heavy-items.component';
import { HeavyItemsModule } from '../modules/heavy-items/heavy-items.module';
import { AfterOrderInterRegionalComponent } from '../modules/after-order-inter-regional/after-order-inter-regional.component';
import { InterRegionalPaymentSuccessComponent } from '../modules/inter-regional/inter-regional-payment-success/inter-regional-payment-success.component';



const routes: Route[] = [
  {
    path: '',
    component: LayoutComponent,
    children: [
      { path: '', canActivate: [AuthGuardGuard], component: HomeComponent },
      {
        path: 'standard',
        canActivate: [AuthGuardGuard],
        component: StandardOrderComponent,
        canDeactivate: [PendingChangesGuard],
      },
      {
        path: 'standard-heavy',
        canActivate: [AuthGuardGuard],
        canDeactivate: [PendingChangesGuard],
        component: HeavyItemsComponent,
      },
      {
        path: 'bulk',
        canActivate: [AuthGuardGuard],
        canDeactivate: [PendingChangesGuard],
        component: BulkOrderComponent,
      },
      {
        path: 'inter-regional',
        canActivate: [AuthGuardGuard, CountryRoutingGuard],
        canDeactivate: [PendingChangesGuard],
        component: InterRegionalComponent,
      },

      {
        path: 'inter-state',
        canActivate: [AuthGuardGuard, CountryRoutingGuard],
        canDeactivate: [PendingChangesGuard],
        component: InterRegionalComponent,
      },
      {
        path: 'orders',
        canActivate: [AuthGuardGuard],
        children: [
          {
            path: '',
            loadChildren: () =>
              import('../modules/order-details/order-details.module').then(
                (m) => m.OrderDetailsModule
              ),
          },
        ],
      },
      {
        path: 'wallet-transaction',
        canActivate: [AuthGuardGuard],
        component: WalletLayoutComponent,
      },
      {
        path: 'order-payment-status/:status/:transactionId/:orderId/:orderType',
        component: AfterOrderScreenComponent,
      },
      {
        path: 'order-payment-status',
        component: AfterOrderInterRegionalComponent,
      },
      {
        path: 'wallet-payment-status',
        component: WalletPaymentHandlingComponent,
      },
      {
        path: 'order-successful',
        component: OrderSuccessComponent,
      },
      {
        path: 'pending-feedback',
        component: PendingFeedbackListingComponent,
      },
      {
        path: 'inter-order-details',
        canActivate: [AuthGuardGuard],
        component: OrderInterRegionalDetailsComponent,
      },
      {
        path: 'inter-regional-payment-success',
        canActivate: [CountryRoutingGuard],
        component: InterRegionalPaymentSuccessComponent,
      },
      {
        path: 'inter-state-payment-success',
        canActivate: [CountryRoutingGuard],
        component: InterRegionalPaymentSuccessComponent,
      },


    ],
  },
];

@NgModule({
  declarations: [LayoutComponent, AfterOrderScreenComponent],
  imports: [
    CommonModule,
    CommonComponentsModule,
    RouterModule,
    MatIconModule,
    MatButtonModule,
    PhlenuWalletModule,
    MatTooltipModule,
    BulkOrderModule,
    HomeModule,
    MatDialogModule,
    StandardOrderModule,
    InterRegionalModule,
    HeavyItemsModule,
    PendingFeedbackListingModule,
    RouterModule.forChild(routes),
  ],
  exports: [LayoutComponent],
  providers: [PendingChangesGuard, CountryRoutingGuard],
})
export class LayoutModule { }
